import React from 'react'

export default function Footer() {
  return (
      <>
       <p className='footer'>
      
      <span>
        Developed by <span className="user">Tejas M N </span> using React ❤️
      </span>
      <br></br>
      <span>
      GitHub Repository -{" "}
        <a style={{color:'greenyellow'}}
          href="https://github.com/tejas-mn/Sorto-Viz"
          target="_blank"
          rel="noreferrer"
        >
          Link
        </a>{" "}
      </span>
    </p>
    <br></br>
      </>
    
  )
}
